'use client';
import { Heading } from '../heading/heading';
import { IconButton } from '../iconButton/iconButton';
import styles from './share.module.scss';

type Platform = 'linkedin' | 'twitter' | 'facebook' | 'email';

export const Share = () => {
  const share = (platform: Platform) => {
    let baseUrl = '';

    switch (platform) {
      case 'linkedin':
        baseUrl = `https://www.linkedin.com/sharing/share-offsite/?url=`;
        break;
      case 'twitter':
        baseUrl = `http://www.twitter.com/share?url=`;
        break;
      case 'facebook':
        baseUrl = `https://www.facebook.com/sharer/sharer.php?u=`;
        break;
      default:
        baseUrl = `mailto:?subject=Ik wil deze pagina met je delen&amp;body=Check deze site: `;
    }

    window.open(`${baseUrl}${encodeURIComponent(`${window.location}`)}`);
  };

  return (
    <div className={styles.share}>
      <Heading style="regular" level="h2" tag="p">
        Deel!
      </Heading>
      <ul className={styles.buttons}>
        <li>
          <IconButton
            style="secondary"
            shape="circle"
            icon="Linkedin"
            onClick={() => share('linkedin')}
          />
        </li>
        <li>
          <IconButton
            style="secondary"
            shape="circle"
            icon="Twitter"
            onClick={() => share('twitter')}
          />
        </li>
        <li>
          <IconButton
            style="secondary"
            shape="circle"
            icon="Facebook"
            onClick={() => share('facebook')}
          />
        </li>
        <li>
          <IconButton
            style="secondary"
            shape="circle"
            icon="Email"
            onClick={() => share('email')}
          />
        </li>
      </ul>
    </div>
  );
};
